import { render, staticRenderFns } from "./CrashCourseMaterial.vue?vue&type=template&id=bc3e2744&scoped=true&"
import script from "./CrashCourseMaterial.vue?vue&type=script&lang=js&"
export * from "./CrashCourseMaterial.vue?vue&type=script&lang=js&"
import style0 from "./CrashCourseMaterial.vue?vue&type=style&index=0&id=bc3e2744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3e2744",
  null
  
)

export default component.exports